/**
 * Service for handling customer domain specific data, such as self-reported salaries.
 */
angular.module('psModule').factory('CustomerDomainService', function($resource) {
    'use strict';

    const resource = $resource('/ps/api/individuals/self-reported-salaries/:id', { id: '@id' }, {
        /**
         * Saves a new self-reported salary.
         * The backend will associate it with the currently logged-in user.
         */
        saveSelfReportedSalary: {
            method: 'POST'
        },
        /**
         * Deletes a self-reported salary by its ID.
         */
        deleteSelfReportedSalary: {
            method: 'DELETE',
        }
    });

    return {
        /**
         * Defines the data structure for creating a new salary.
         * @typedef {object} CreateSelfReportedSalaryDto
         * @property {number} annualPensionSalaryAmount - The annual salary in SEK.
         * @property {string} startDate - The start date in 'YYYY-MM-DD' format.
         */

        /**
         * Saves a new self-reported salary for the authenticated user.
         * @param {CreateSelfReportedSalaryDto} salaryData - The salary data object, which must conform to the CreateSelfReportedSalaryDto type defined above.
         * @returns {Promise} A promise that resolves with the created salary data from the backend.
         */
        saveSelfReportedSalary: function(salaryData) {
            return resource.saveSelfReportedSalary(salaryData).$promise;
        },

        /**
         * Deletes a self-reported salary by its ID.
         * @param {string} salaryId - The unique ID of the salary to delete.
         * @returns {Promise} A promise that resolves when the deletion is complete.
         */
        deleteSelfReportedSalary: function(salaryId) {
            return resource.deleteSelfReportedSalary({ id: salaryId }).$promise;
        }
    };
});
